<template>
    
</template>

<script>
    export default {
        name: "RightPanel"
    }
</script>

<style scoped>

</style>
